import React, { useEffect, useRef, useState } from 'react';
import { Box, InputBase } from '@mui/material';

import { useWidgetFrame } from '../frameContext';

/** Inline-editable sticky note; the parent persists the debounced value. */
export default function NoteBody({ value = '', onChange, placeholder }) {
  const frame = useWidgetFrame();
  const [text, setText] = useState(value);
  const timer = useRef(null);
  useEffect(() => setText(value), [value]);
  const handleChange = (event) => {
    const next = event.target.value;
    setText(next);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onChange?.(next), 800);
  };
  useEffect(() => () => clearTimeout(timer.current), []);
  return (
    <Box sx={{ flex: 1, minHeight: 0, p: 1.5, bgcolor: '#fffbeb', display: 'flex' }}>
      <InputBase
        multiline
        fullWidth
        value={text}
        placeholder={placeholder}
        onChange={handleChange}
        readOnly={frame?.mode === 'edit' || frame?.inPreview}
        sx={{ alignItems: 'flex-start', fontSize: 13.5, lineHeight: 1.5, color: 'text.primary', '& textarea': { height: '100% !important', overflow: 'auto !important' } }}
        inputProps={{ 'data-testid': 'widget-note-input' }}
      />
    </Box>
  );
}
